import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, mergeProps, createCommentVNode } from 'vue';
import { OrIconV3 as script$1, IconVariant, IconSize } from '../or-icon-v3/index.js';

var IndicatorColor;
(function (IndicatorColor) {
  IndicatorColor["Success"] = "success";
  IndicatorColor["Neutral"] = "neutral";
  IndicatorColor["Warning"] = "warning";
  IndicatorColor["Outline"] = "outline";
  IndicatorColor["Error"] = "error";
  IndicatorColor["Inherit"] = "inherit";
})(IndicatorColor || (IndicatorColor = {}));
var IndicatorSize;
(function (IndicatorSize) {
  IndicatorSize["XL"] = "xl";
  IndicatorSize["L"] = "l";
  IndicatorSize["M"] = "m";
  IndicatorSize["S"] = "s";
})(IndicatorSize || (IndicatorSize = {}));

const IndicatorShape = {
  [IndicatorSize.XL]: [
  // Layout
  'shrink-0',
  // Box
  'w-[24px]', 'h-[24px]',
  // Shape
  'rounded-full'],
  [IndicatorSize.L]: [
  // Layout
  'shrink-0',
  // Box
  'w-[20px]', 'h-[20px]',
  // Shape
  'rounded-full'],
  [IndicatorSize.M]: [
  // Layout
  'shrink-0',
  // Box
  'w-[16px]', 'h-[16px]',
  // Shape
  'rounded-full'],
  [IndicatorSize.S]: [
  // Layout
  'shrink-0',
  // Box
  'w-[8px]', 'h-[8px]',
  // Shape
  'rounded-full']
};
const IndicatorThemes = {
  [IndicatorColor.Error]: ['theme-foreground-on-error', 'dark:theme-foreground-on-error-dark', 'theme-background-error', 'dark:theme-background-error-dark'],
  [IndicatorColor.Neutral]: ['theme-foreground-on-primary', 'dark:theme-foreground-on-primary-dark', 'theme-background-primary', 'dark:theme-background-primary-dark'],
  [IndicatorColor.Inherit]: [],
  [IndicatorColor.Outline]: ['theme-foreground-on-secondary', 'dark:theme-foreground-on-secondary-dark', 'theme-background-secondary', 'dark:theme-background-secondary-dark'],
  [IndicatorColor.Success]: ['theme-foreground-on-success', 'dark:theme-foreground-on-success-dark', 'theme-background-success', 'dark:theme-background-success-dark'],
  [IndicatorColor.Warning]: ['theme-foreground-on-warning', 'dark:theme-foreground-on-warning-dark', 'theme-background-warning', 'dark:theme-background-warning-dark']
};
const IndicatorIconThemes = {
  [IndicatorColor.Error]: ['theme-foreground-error', 'dark:theme-foreground-error-dark'],
  [IndicatorColor.Neutral]: ['theme-foreground-primary', 'dark:theme-foreground-primary-dark'],
  [IndicatorColor.Inherit]: [],
  [IndicatorColor.Outline]: ['theme-foreground-secondary', 'dark:theme-foreground-secondary-dark'],
  [IndicatorColor.Success]: ['theme-foreground-success', 'dark:theme-foreground-success-dark'],
  [IndicatorColor.Warning]: ['theme-foreground-warning', 'dark:theme-foreground-warning-dark']
};

var script = defineComponent({
  name: 'OrIndicator',
  components: {
    OrIcon: script$1
  },
  props: {
    size: {
      type: String,
      default: () => IndicatorSize.M
    },
    color: {
      type: String,
      default: IndicatorColor.Neutral
    },
    icon: {
      type: [String, Object, undefined],
      default: undefined
    }
  },
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-indicator-v3', ...(!props.icon ? IndicatorShape[props.size] : []), ...(!props.icon ? IndicatorThemes[props.color] : [])]);
    const iconContainerStyles = computed(() => [...IndicatorIconThemes[props.color]]);
    // Icon props
    const iconProps = computed(() => {
      return typeof props.icon === 'string' ? {
        icon: props.icon,
        variant: IconVariant.Inherit,
        size: props.size === IndicatorSize.S ? IconSize.M : props.size
      } : {
        variant: IconVariant.Inherit,
        size: props.size === IndicatorSize.S ? IconSize.M : props.size,
        ...props.icon
      };
    });
    return {
      iconContainerStyles,
      iconProps,
      root,
      rootStyles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.icon ? (openBlock(), createBlock(_component_OrIcon, mergeProps({
    key: 0,
    class: _ctx.iconContainerStyles
  }, _ctx.iconProps), null, 16 /* FULL_PROPS */, ["class"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-indicator-v3/OrIndicator.vue";

export { IndicatorColor, IndicatorSize, script as OrIndicatorV3 };
